import React from 'react';
import { Route, Switch } from 'react-router';
import Layout from 'components/Layout';
import List from './List';
import Form from './Form';

const Movie = () => (
  <Layout>
    <Switch>
      <Route exact path="/movies" component={List} />
      <Route exact path="/movies/new" component={Form} />
      <Route exact path="/movies/:id" component={Form} />
    </Switch>
  </Layout>
);

export default Movie;
